<template>
  <IQOS :title="$t('subscription.title')" v-if="shouldShowBlock">
    <!-- <div class="mb-15">
      <div class="system-row i">INSIDE</div>
      <div class="system-comment">$25/м. | Активна до 10.07.2020</div>
    </div>
    <div class="mb-15">
      <div class="system-row p">TAKEAWAY</div>
      <div class="system-comment">$25/м. | Активна до 10.07.2020</div>
    </div>
    <div class="mb-15">
      <div class="system-row d">DELIVERY</div>
      <div class="system-comment">$25/м. | Активна до 10.07.2020</div>
    </div>
    <div class="mb-15">
      <div class="system-row r">RESERVE</div>
      <div class="system-comment">$25/м. | Активна до 10.07.2020</div>
    </div>
    <div class="mb-15">
      <div class="system-row pro">PRO</div>
      <div class="system-comment">$25/м. | Активна до 10.07.2020</div>
    </div> -->
    <div v-if="shouldShowBlock">
      <ActiveSubscriptionCard
        class="mb-15"
        v-for="sub in activeSubscriptions"
        :key="sub._id"
        :subscription="sub"
      />
      <DashboardButton @click="$router.push('/systems')" class="w-100">
        {{ $t("general.cafe.settings") }}
      </DashboardButton>
    </div>
    <div v-else>
      <p class="comment pt-0 mt-0 c-grey">
        {{ $t("general.cafe.no_subscriptions") }}
      </p>
      <DashboardButton
        class="w-100 mt-15"
        @click="$router.push('/systems')"
        v-if="hasSettingsPermission"
      >
        {{ $t("general.cafe.settings") }}
      </DashboardButton>
    </div>
  </IQOS>
  <!-- <div v-if="shouldShowBlock">
    <h5 class="title">{{ $t('subscription.title') }}</h5>
    <SubscriptionBadge
      :subscription="subscriptions.inside"
      noButton
      v-if="!isHotel && checkFeatureMode('inside')"
    />
    <SubscriptionBadge
      class="badge-align"
      :subscription="subscriptions.hotels"
      noButton
      v-if="isHotel && checkFeatureMode('inside')"
    />
    <SubscriptionBadge
      :subscription="subscriptions.inside_lite"
      noButton
      v-else-if="isInsideLiteEnabled && subscriptions.inside_lite && checkFeatureMode('inside') "
    />
    <SubscriptionBadge
      class="badge-align"
      :subscription="subscriptions.preorder"
      noButton
      v-if="subscriptions.preorder && checkFeatureMode('preorder')"
    />
    <SubscriptionBadge
      class="badge-align"
      :subscription="subscriptions.delivery"
      noButton
      v-if="subscriptions.delivery && checkFeatureMode('delivery')"
    />
    <SubscriptionBadge
      class="badge-align"
      :subscription="subscriptions.reserve"
      noButton
      v-if="subscriptions.reserve && checkFeatureMode('reserve')"
    />
     <DashboardButton class="mt-15 w-100" @click="$router.push('/systems')" v-if="hasSettingsPermission">
       {{ $t('general.cafe.settings' )}}
     </DashboardButton>
  </div>
  <div v-else>
    <h5 class="title">{{ $t('subscription.title') }}</h5>
    <p class="comment pt-0 mt-0 c-grey">
      {{ $t('general.cafe.no_subscriptions') }}
    </p>
    <DashboardButton class="w-100 mt-15" @click="$router.push('/systems')" v-if="hasSettingsPermission">
       {{ $t('general.cafe.settings' )}}
     </DashboardButton>
  </div> -->
</template>

<script>
import SubscriptionBadge from "@/components/subscriptions/SubscriptionBadge.vue";
import DashboardButton from "@/components/DashboardButton.vue";
import IQOS from "@/components/IQOS.vue";
import moment from "moment";

import ActiveSubscriptionCard from "@/components/general/ActiveSubscriptionCard.vue";

export default {
  components: {
    SubscriptionBadge,
    DashboardButton,
    IQOS,
    ActiveSubscriptionCard,
  },
  data() {
    return {};
  },
  methods: {
    checkFeatureMode(mode) {
      return this.$store.getters["worldwide/checkSystem"](mode);
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    subscriptions() {
      return this.$store.getters["subscriptions/all"];
    },
    isInsideLiteEnabled() {
      return !!this.cafe.inside_lite;
    },
    atLeastOneModeActive() {
      return (
        this.cafe.modes.inside ||
        this.cafe.modes.delivery ||
        this.cafe.modes.preorder ||
        this.cafe.modes.reserve ||
        this.isInsideLiteEnabled
      );
    },
    activeSubscriptions() {
      return Object.values(this.subscriptions).filter((s) => !!s.liqpay_id);
    },
    hasSettingsPermission() {
      return this.$store.getters.checkUserPemission("systems");
    },
    isHotel() {
      return this.$store.getters.isHotel;
    },
    shouldShowBlock() {
      let subscriptions = Object.values(this.subscriptions);

      const paid_sub = subscriptions.find((s) => {
        if (!this.atLeastOneModeActive) return false;

        if (!s.paid_until || !s.liqpay_id) return false;

        if (moment().isAfter(s.paid_until)) return false;

        return true;
      });

      return !!paid_sub;
    },
  },
};
</script>

<style scoped>
.mb-15 {
  margin-bottom: 1.6666666666666667vh;
}
.system-row {
  height: 3.5555555555555554vh;
  font-size: 1.5vh;
  background: #000000;
  border-radius: 0.3333333333333333vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}
.i {
  color: #ededed;
}
.p {
  color: #ffd2a8;
}
.d {
  color: #cbd9e6;
}
.r {
  color: #aeccc6;
}
.pro {
  color: #e2223b;
}
.system-comment {
  font-size: 1.3333333333333333vh;
  line-height: 1.5555555555555556vh;
  color: #aeccc6;
  margin-top: 0.6666666666666666vh;
}
/* old-styles */
h2 {
  font-size: 4.5vh;
  padding: 0;
  display: block;
  min-width: 16vh;
}

h3 {
  font-size: 2.5vh;
}

h5.title {
  margin-bottom: 2.2vh;
  font-size: 2vh;
  color: #ededed;
}

span.commission {
  background: #464646;
  padding: 0.4vh 2vh 0.4vh 3vh;
  display: inline-flex;
  z-index: 0;
  color: #ededed;
  width: 8.5vh;
  margin-left: -1vh;
  border-radius: 0 0.8vh 0.8vh 0;
  font-size: 1.7vh;
}

.commission.fix-price {
  padding: 0.4vh 0 0.4vh 1.8vh;
}

.default-btn:hover {
  background: #129b81;
  border: 1px solid transparent;
}

.inside {
  background: #262626 !important;
  color: #ededed;
}
.preorder {
  background: #ffd2a8 !important;
  color: #1d1d1b !important;
}
.delivery {
  background: #cbd9e6 !important;
  color: #1d1d1b !important;
}
.reserve {
  background: #aeccc6 !important;
  color: #1d1d1b !important;
}

.buy-history {
  max-height: 7vh;
  margin-top: 3vh;
  overflow: auto;
  background: linear-gradient(
    180deg,
    rgba(29, 29, 27, 0) 39.58%,
    #1d1d1b 92.19%
  );
}

.buy-history .item {
  font-size: 1.5vh;
  padding-top: 0.5vh;
  color: #ededed;
  line-height: normal;
}

.buy-history .item.filled {
  color: #129b81;
}

small.status-flag {
  color: #908f8d;
  line-height: normal;
  display: block;
  font-size: 1.5vh;
  padding-top: 1vh;
}

small.status-flag.active {
  color: #129b81;
}

small.status-flag.end {
  color: #e2223b;
}

.flag {
  display: flex;
  margin-top: 1.2vh;
  position: relative;
}

.flag:first-child {
  margin: 0;
}

.flag .mode {
  color: #ededed;
  text-align: center;
  position: relative;
  z-index: 2;
  font-weight: bold;
  width: 11vh;
  display: inline-block;
  border-radius: 0.8vh;
  font-size: 1.7vh;
  background: #262626;
  padding: 0.5vh 0 0.5vh;
}

.flag-disabled {
  color: #a4a3a1;
}

.subscription-active {
  margin-bottom: 1.1vh;
  font-size: 2vh;
}

.subscription-badge {
  border: 2px solid #129b81;
  color: #129b81;
  padding: 2vh 0.5vh 0;
  align-self: center;

  height: 13vh;
  border-radius: 1.3vh;
  text-align: center;
  width: fit-content;
  display: block;
  width: 20vh;
}

.subscription-badge-notactive {
  border: 2px solid #e2223b;
  color: #e2223b;
}

.subscription-btn,
.history-btn {
  background: #129b81;
  color: white;
}

.history-btn {
  background: transparent;
  color: #908f8d;
  padding: 0.4vh 0 0.5vh;
  border: 1px solid #908f8d;
}

.marketplace-prices-box {
  display: block;
  margin: -3.3vh 0 -3.3vh auto;

  padding: 3.3vh 0 3.3vh 3.3vh;
  border-left: 1px solid #464646;
  width: 45vh;
}

.general-wrapper {
  display: flex;
  padding-top: 2.2vh;
  justify-content: space-between;
  width: 100%;
}

.pl-25 {
  padding-left: 2.8vh;
  display: grid;
}

p {
  margin-bottom: 0;
}

.subscription-tarrifs {
  margin-top: 1.2vh;
  display: block;
}

.choose-period img {
  height: 2vh;
  width: auto;
  display: block;
  margin: 2vh auto 0;
}

.period-box input {
  width: 100%;
  background: transparent;
  color: #ededed;
  outline: none;
  padding: 1.8vh 2vh;
  border: none;
}

.choose-period {
  width: 45vh;
  position: absolute;
  left: 0;
  right: 0;
  padding: 5vh;
  top: 50%;
  transform: translateY(-50%);
  border: 1px solid #464646;
  margin: 0 auto;
  color: #ededed;
}

.choose-period h3 {
  font-size: 2.8vh;
  line-height: 0.8;
  padding: 0 0 2.2vh;
}

.period-box {
  border-radius: 1vh;
  border: 1px solid #1d1d1b;
  padding: 1.8vh 2vh;
  margin-top: 1.1vh;
  font-size: 2vh;
}

.period-box img {
  height: 3vh;
  width: auto;
  align-self: center;
}
.period-box.active {
  background: #1d1d1b;
  border: 2px solid #129b81;
}
header {
  padding: 6vh 0 0 0;
  width: 118vh;
  margin: 0 auto;
  color: #ededed;
}

header h2 {
  padding: 1vh 0 0 0;
  font-size: 4vh;
}

button.pay {
  background: #11d180;
  width: 100%;
  border: none;
  color: #ededed;
  border-radius: 1vh;
  margin-top: 2vh;
  font-size: 2vh;
  padding: 1.3vh 1vh;
  cursor: pointer;
}

button.pay:disabled {
  opacity: 0.7;
}

.payment-block {
  position: absolute;
  bottom: 18vh;
  left: 0;
  right: 0;
  text-align: center;
}

.infinity {
  width: 10vh;
}

.badge-align {
  margin-top: 2.2vh;
}
</style>
